import { HOME } from "@/constants/testIds";

export default function MissionFramingBanner() {
  return (
    <section className="bg-zinc-950 text-white py-10 border-b border-white/10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p data-testid={HOME.missionStatement} className="font-display font-semibold text-lg md:text-xl leading-relaxed">
          "An integrated problem requires an integrated solution: no one should have to face racial bias
          alone. BBAP is a Black-founded movement, and your experience matters. Volunteers, community
          members, and allies can help build the network of people and practical resources that support
          those affected, while BBAP documents patterns and develops solutions. Join us or donate to help
          build and sustain that support and action."
        </p>
        <p className="text-zinc-400 text-sm mt-4 leading-relaxed max-w-2xl mx-auto">
          This is not one-sided. BBAP isn't about businesses owned by one race versus another. It's about
          identifying which people, businesses, neighborhoods, and environments — of any background — treat
          others with dignity, and which don't.
        </p>
      </div>
    </section>
  );
}
